/**
 * Types for the `getMapKitToken` Cloud Function callable (ADR-096).
 *
 * Returns a short-lived MapKit JS token for the admin portal's
 * location picker. The admin caches the token and refreshes before
 * expiry.
 */

import { z } from 'zod';

export const getMapKitTokenInputSchema = z
  .object({
    /** The admin origin for the JWT origin claim (e.g. "http://localhost:5173"). */
    origin: z.string().optional(),
  })
  .strict();

export type GetMapKitTokenInput = z.infer<typeof getMapKitTokenInputSchema>;

export interface GetMapKitTokenResponse {
  /** Signed MapKit JS JWT. */
  token: string;
  /** Unix timestamp (seconds) when this token expires. */
  expiresAt: number;
}
